/*
 * @Descripttion:
 * @Author: linwc
 * @Date: 2025-07-15 17:58:33
 * @LastEditors: linwc
 * @LastEditTime: 2025-07-30 17:06:46
 */
export const cloudApi = {
  GET_TOPOLOGY_TREEDATA: '/topology/info/{group_id}?with_wired_terminal={with_wired_terminal}',
  GET_DEVICE_PANELPOERTS: '/maint/devices/port'
};
